import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface IbUserAccountsDynamicMutationAPI {
  updateMultipleGraphQlMutations: UseMutateAsyncFunction<
    Record<string, any>,
    Error,
    {
      mutation: string;
      data: Record<string, any>;
    }
  >;
  error: string | null;
  status: MutationStatus;
}

const useIbUserAccountsDynamicMutationAPI =
  (): IbUserAccountsDynamicMutationAPI => {
    const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();

    const { mutateAsync, error, status } = useMutation(
      ({ mutation, data }: { mutation: string; data: Record<string, any> }) => {
        return ibUserAccountsGraphQLService.ibUserAccountsGraphQlMutation(
          mutation,
          data
        );
      },
      {
        mutationKey: ['updateMultipleGraphQlMutations']
      }
    );

    return {
      updateMultipleGraphQlMutations: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useIbUserAccountsDynamicMutationAPI };
